import { Component, OnInit, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IMToolService } from '../../services/im-tool.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/services/toast.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as constants from "src/app/config/app-constants";
import { CustomerLegacyConnectRecommendDrugInfo, LegacyConnectRecommendDrugInfo } from '../../models/legacy-connect-customer-recommended-drugs';
import { ImToolData } from '../../services/im-tool-data.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ExportFileInfo } from '../../models/export-file-info';
import { ExcelExportService } from '../../services/excel-export-service.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-customer-drug-list-legacy-connect',
  templateUrl: './customer-drug-list-legacy-connect.component.html',
  styleUrls: ['./customer-drug-list-legacy-connect.component.scss'],
  standalone: false
})
export class CustomerDrugListLegacyConnectComponent implements OnInit {

  customerId: string | null = null;
    drugList: CustomerLegacyConnectRecommendDrugInfo;
    analysisDrugList: LegacyConnectRecommendDrugInfo[] = [];
    notAvailableDrugList: LegacyConnectRecommendDrugInfo[] = [];
    excludedDrugList: LegacyConnectRecommendDrugInfo[] = [];
    customerName: string = "";
    targetInstallDate: string = "";
    subDeviceTypeName: string = "";
    searchText:string='';
    exportFileType: number = 0;
    isLegacyConnectMdlLoading: boolean = false;
    legacyConnectMdlFile: Blob | null = null;
    legacyConnectMdlFileName: string = "";
    legacyConnectMdlSourceId: number = 0;
    deviceId: number;
    deviceName: string = "";
    dataSource = new MatTableDataSource<LegacyConnectRecommendDrugInfo>();
    dataSourceExcluded = new MatTableDataSource<LegacyConnectRecommendDrugInfo>();
    tabSelected: number = 0;
    selectedRow;
    @ViewChild(CdkVirtualScrollViewport, { static: true })
    viewport: CdkVirtualScrollViewport;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild("table", { read: MatSort, static: true }) sort: MatSort;
    @ViewChild("table1", { read: MatSort, static: true }) sort1: MatSort;
    @ViewChild("TABLE") table: ElementRef;
    @ViewChild("TABLE1") table1: ElementRef;
    @Output() sortChange: EventEmitter<MatSort> = new EventEmitter<MatSort>();

  isProductId = true;
  isNDC = true;
  isDrugName = true;
  isCustomerDrugName = true;
  isGtin = true;
  isRank = true;
  isThirtyDramCapacity = true;
  isProductScanCode = false;
  isPacksize = false;
  isPurchaseQty = false;
  isDrugSchedule = false;
  isDrugForm = false;
  isProductType = false;
  isUomClass = false;
  isSellUOM = false;
  isSlotArea = false;
  isSlotShelf = false;
  isSlotBin = false;
  isLocType = false;
  isRop = false;
  isCapacity = false;
  isQtyonShelf = false;
  isLotNo = false;
  isExpDate = false;
  isVialSize = false;
  isVialCapacity = false;
  isVialEnabled = false;
  isVendorPartNo = false;
  isSpecialty = false;
  isOrmd = false;
  isRefrigerateFlag = false;
  isRxQty = false;
  isUsage = false;
  isMaxRecommendedForUse = false;
  isOralsolid = false;
  isCellCapacitySmall = false;
  isCellCapacityLarge = false;
  isNA = false;

  isProductIdExcluded = true;
  isNDCExcluded = true;
  isDrugNameExcluded = true;
  isCustomerDrugNameExcluded = true;
  isExcludedReason = true;
  isGtinExcluded = true;
  isRankExcluded = true;
  isThirtyDramCapacityExcluded = true;
  isProductScanCodeExcluded = false;
  isPacksizeExcluded = false;
  isPurchaseQtyExcluded = false;
  isDrugScheduleExcluded = false;
  isDrugFormExcluded = false;
  isProductTypeExcluded = false;
  isUomClassExcluded = false;
  isSellUOMExcluded = false;
  isSlotAreaExcluded = false;
  isSlotShelfExcluded = false;
  isSlotBinExcluded = false;
  isLocTypeExcluded = false;
  isRopExcluded = false;
  isCapacityExcluded = false;
  isQtyonShelfExcluded = false;
  isLotNoExcluded = false;
  isExpDateExcluded = false;
  isVialSizeExcluded = false;
  isVialCapacityExcluded = false;
  isVialEnabledExcluded = false;
  isVendorPartNoExcluded = false;
  isSpecialtyExcluded = false;
  isOrmdExcluded = false;
  isRefrigerateFlagExcluded = false;
  isRxQtyExcluded = false;
  isUsageExcluded = false;
  isMaxRecommendedForUseExcluded = false;
  isOralsolidExcluded = false;
  isCellCapacitySmallExcluded = false;
  isCellCapacityLargeExcluded = false;
  isNAExcluded = false;



  displayedColumns: string[] = [
    "productId",
    "ndc",
    "drugName",
    "customerDrugName",
    'productScanCode',
    "gtin",
    "packsize",
    "purchaseQty",
    "drugSchedule",
    "drugForm",
    "productType",
    "uomClass",
    "sellUOM",
    "slotArea",
    "slotShelf",
    "slotBin",
    "locType",
    "rop",
    "capacity",
    "qtyonShelf",
    "lotNo",
    "expDate",
    "vialSize",
    "vialCapacity",
    "vialEnabled",
    "vendorPartNo",
    "specialty",
    "ormd",
    "refrigerateFlag",
    "rank",
    "rxQty",
    "usage",
    "thirtyDramCapacity",
    "maxRecommendedForUse",
    "isOralSolid",
    "cellCapacitySmall",
    "cellCapacityLarge",
    "na",
    "action"
  ];

  displayedColumnsExcluded: string[] = [
    "productId",
    "ndc",
    "excludedReason",
    "drugName",
    "customerDrugName",
    'productScanCode',
    "gtin",
    "packsize",
    "purchaseQty",
    "drugSchedule",
    "drugForm",
    "productType",
    "uomClass",
    "sellUOM",
    "slotArea",
    "slotShelf",
    "slotBin",
    "locType",
    "rop",
    "capacity",
    "qtyonShelf",
    "lotNo",
    "expDate",
    "vialSize",
    "vialCapacity",
    "vialEnabled",
    "vendorPartNo",
    "specialty",
    "ormd",
    "refrigerateFlag",
    "rank",
    "rxQty",
    "usage",
    "thirtyDramCapacity",
    "maxRecommendedForUse",
    "isOralSolid",
    "cellCapacitySmall",
    "cellCapacityLarge",
    "na",
    "action"
  ];

  constructor(
    private imtoolService: IMToolService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private exportService: ExcelExportService,
  ) {

  }

  ngOnInit(): void {
    combineLatest([this.activateRoute.paramMap, this.activateRoute.queryParamMap]).subscribe(([params, queryParams]) => {
      const routeCustomerData = this.getRouteCustomerData(params.get("customerid"));
      this.customerId = routeCustomerData.customerId;
      this.legacyConnectMdlSourceId = Number(queryParams.get("sourceId") || queryParams.get("sourceid") || routeCustomerData.sourceId || 0);
      if (!this.customerId) {
        return;
      }
      this.getLegacyConnectRecommendedDrugData(this.customerId);
    });
  }

  getRouteCustomerData(customerId: string | null): { customerId: string | null; sourceId: string | null } {
    if (!customerId) {
      return { customerId, sourceId: null };
    }

    const decodedCustomerId = decodeURIComponent(customerId);

    if (!decodedCustomerId.includes("?")) {
      return { customerId: decodedCustomerId, sourceId: null };
    }

    const [cleanCustomerId, queryString] = decodedCustomerId.split("?");
    const routeQueryParams = new URLSearchParams(queryString);
    return {
      customerId: cleanCustomerId,
      sourceId: routeQueryParams.get("sourceId") || routeQueryParams.get("sourceid")
    };
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSourceExcluded.sort = this.sort1;
  }

  defaultSortSet(columnName: string, dir: any) {
    const sortState: Sort = { active: columnName, direction: dir };
    this.sort.active = sortState.active;
    this.sort.direction = sortState.direction;
    this.sort.sortChange.emit(sortState);
  }


  openImportWizard() {
    
  }

  downloadFile(data: number | string) {
    if (Number(data) == 1) {
      this.downloadLegacyConnectMdlFile();
    }
    else if (Number(data) == 2) {
      this.customerDrugExport();
    }
    this.exportFileType = 0;
  }

  downloadLegacyConnectMdlFile() {
    if (!this.legacyConnectMdlFile) {
      return;
    }

    const url = URL.createObjectURL(this.legacyConnectMdlFile);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = this.legacyConnectMdlFileName || `Parata Connect MDL-${this.customerName}-${this.deviceName}-${this.getCurrentDate()}.xlsx`;
    anchor.click();
    URL.revokeObjectURL(url);
  }

  prepareLegacyConnectMdlFile(legacyConnectRecommendationData: any) {
    this.isLegacyConnectMdlLoading = true;
    this.legacyConnectMdlFile = null;
    this.legacyConnectMdlFileName = "";
    const sourceId = Number(legacyConnectRecommendationData.dataSource || this.legacyConnectMdlSourceId || 0);

    if (!sourceId) {
      this.isLegacyConnectMdlLoading = false;
      this.toastService.openToast(
        "Unable to prepare Parata Connect MDL because data source is missing.",
        constants.ToastPanelType.error,
        2
      );
      return;
    }

    const mdlData = legacyConnectRecommendationData.drugs || [];

    this.imtoolService.getLegacyConnectMdlFile(this.getLegacyConnectMdlRequestData(mdlData), sourceId).subscribe(
      (response) => {
        this.legacyConnectMdlFile = response.body;
        this.legacyConnectMdlFileName = this.getFileNameFromContentDisposition(response.headers?.get('content-disposition')) || `Parata Connect MDL-${this.customerName}-${this.deviceName}-${this.getCurrentDate()}.xlsx`;
        this.isLegacyConnectMdlLoading = false;
      },
      (error: HttpErrorResponse) => {
        this.isLegacyConnectMdlLoading = false;
        this.toastService.openToast(
          error.error?.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  getLegacyConnectMdlRequestData(drugList: LegacyConnectRecommendDrugInfo[]): any[] {
    return drugList.map((drug) => ({
      productId: this.getMdlStringValue(drug.productID),
      ndc: this.getMdlStringValue(drug.ndc),
      description: this.getMdlStringValue(drug.customerDrugName || drug.drugName),
      prodScanCode: this.getMdlStringValue(drug.productScanCode),
      gtin: this.getMdlStringValue(drug.gtin),
      packsize: this.getMdlNumberValue(drug.packsize ?? drug.packSize),
      purchaseQty: this.getMdlNumberValue(drug.purchaseQty),
      drug_Schedule: this.getMdlNumberValue(drug.drugSchedule),
      drug_Form: this.getMdlStringValue(drug.drugForm),
      productType: this.getMdlStringValue(drug.productType),
      uomClass: this.getMdlStringValue(drug.uomClass),
      sellUOM: this.getMdlStringValue(drug.sellUOM),
      slotArea: this.getMdlStringValue(drug.slotArea),
      slotShelf: this.getMdlStringValue(drug.slotShelf),
      slotBin: this.getMdlStringValue(drug.slotBin),
      locType: this.getMdlStringValue(drug.locType),
      rop: this.getMdlStringValue(drug.rop),
      capacity: this.getMdlStringValue(drug.capacity),
      qtyonShelf: this.getMdlStringValue(drug.qtyonShelf),
      lotNo: this.getMdlStringValue(drug.lotNo),
      expDate: this.getMdlStringValue(drug.expDate),
      vialSize: this.getMdlStringValue(drug.vialSize),
      vialCapacity: this.getMdlStringValue(drug.vialCapacity),
      vialEnabled: this.getMdlNumberValue(drug.vialEnabled),
      vendorPartNo: this.getMdlStringValue(drug.vendorPartNo),
      specialty: this.getMdlStringValue(drug.specialty),
      ormd: this.getMdlStringValue(drug.ormd),
      refrigerate_flag: this.getMdlStringValue(drug.refrigerateFlag),
      rank: this.getMdlStringValue(drug.rank),
      noOfRxs: drug.rxQty,
      noOfUnits: drug.usage,
      na: this.getMdlNumberValue(drug.na),
      thirtyDramCapacity: this.getMdlNumberValue(drug.thirtyDramCapacity),
      maxRecommendedforUse: this.getMdlStringValue(drug.maxRecomendedforUse),
      isOralSolid: drug.isOralSolid,
      cellCapacitySmall: this.getMdlNumberValue(drug.cellCapacitySmall),
      cellCapacityLarge: this.getMdlNumberValue(drug.cellCapacityLarge)
    }));
  }

  getMdlStringValue(value: any): string {
    return value === null || value === undefined ? "" : value.toString();
  }

  getMdlNumberValue(value: any): number | null {
    if (value === null || value === undefined || value.toString().trim() === "") {
      return null;
    }

    return Number(value);
  }

  getFileNameFromContentDisposition(contentDisposition: string | null): string {
    if (!contentDisposition) {
      return "";
    }

    const fileNameMatch = /filename\*=UTF-8''([^;]+)|filename=([^;]+)/i.exec(contentDisposition);
    return decodeURIComponent((fileNameMatch?.[1] || fileNameMatch?.[2] || "").replace(/['"]/g, ""));
  }

  customerDrugExport() {
    const fileInfo: ExportFileInfo = {
      fileName: `Customer Drug XLSX-${this.customerName}-${this.deviceName}-${this.subDeviceTypeName || ""}- ${
        this.getCurrentDate()
      }.xlsx`,
      templates: [
        {
          data: this.getLegacyConnectCustomerDrugExportData(this.analysisDrugList),
          sheetName: 'Analysis',
          headers: this.getLegacyConnectCustomerDrugExportHeaders()
        },
        {
          data: this.getLegacyConnectCustomerDrugExportData(this.excludedDrugList, true),
          sheetName: 'Excluded',
          headers: this.getLegacyConnectCustomerDrugExportHeaders(true)
        }
      ]
    };
    this.exportService.exportAsExcelFile(fileInfo);
  }

  getLegacyConnectCustomerDrugExportHeaders(includeExcludedReason: boolean = false): string[] {
    const headers = [
      'Product ID',
      'NDC',
      'CDDB Drug Name',
      'Customer Drug Name',
      'Prod Scan Code',
      'GTIN',
      'Pack Size',
      'Purchase Qty',
      'Drug Schedule',
      'Drug Form',
      'Product Type',
      'UOM Class',
      'Sell UOM',
      'Slot Area',
      'Slot Shelf',
      'Slot Bin',
      'Loc Type',
      'ROP',
      'Capacity',
      'Qty on Shelf',
      'Lot No',
      'Exp Date',
      'Vial Size',
      'Vial Capacity',
      'Vial Enabled',
      'Vendor Part No',
      'Specialty',
      'ORMD',
      'Refrigerate Flag',
      'Rank',
      '# of Rxs',
      '# of Units',
      '30 Dram',
      'Max Recommended For Use',
      'Is Oral Solid',
      'Cell Capacity Small',
      'Cell Capacity Large',
      'n/a'
    ];

    return includeExcludedReason
      ? ['Product ID', 'NDC', 'Excluded Reason', ...headers.slice(2)]
      : headers;
  }

  getLegacyConnectCustomerDrugExportData(drugList: LegacyConnectRecommendDrugInfo[], includeExcludedReason: boolean = false): any[] {
    return drugList.map((drug) => {
      const exportRow = includeExcludedReason ? {
        'Product ID': drug.productID,
        'NDC': drug.ndc,
        'Excluded Reason': drug.excludedReason
      } : {
        'Product ID': drug.productID,
        'NDC': drug.ndc
      };

      return {
        ...exportRow,
        'CDDB Drug Name': drug.drugName,
        'Customer Drug Name': drug.customerDrugName,
        'Prod Scan Code': drug.productScanCode,
        'GTIN': drug.gtin,
        'Pack Size': drug.packsize ?? drug.packSize,
        'Purchase Qty': drug.purchaseQty,
        'Drug Schedule': drug.drugSchedule,
        'Drug Form': drug.drugForm,
        'Product Type': drug.productType,
        'UOM Class': drug.uomClass,
        'Sell UOM': drug.sellUOM,
        'Slot Area': drug.slotArea,
        'Slot Shelf': drug.slotShelf,
        'Slot Bin': drug.slotBin,
        'Loc Type': drug.locType,
        'ROP': drug.rop,
        'Capacity': drug.capacity,
        'Qty on Shelf': drug.qtyonShelf,
        'Lot No': drug.lotNo,
        'Exp Date': drug.expDate,
        'Vial Size': drug.vialSize,
        'Vial Capacity': drug.vialCapacity,
        'Vial Enabled': drug.vialEnabled,
        'Vendor Part No': drug.vendorPartNo,
        'Specialty': drug.specialty,
        'ORMD': drug.ormd,
        'Refrigerate Flag': drug.refrigerateFlag,
        'Rank': drug.rank,
        '# of Rxs': drug.rxQty,
        '# of Units': drug.usage,
        '30 Dram': drug.thirtyDramCapacity,
        'Max Recommended For Use': drug.maxRecomendedforUse,
        'Is Oral Solid': drug.customerIsOralSolid || drug.isOralSolid,
        'Cell Capacity Small': drug.cellCapacitySmall,
        'Cell Capacity Large': drug.cellCapacityLarge,
        'n/a': drug.na
      };
    });
  }

  openImportWizardCDDB() {

  }

  redirectCustomerList() {
    this.router.navigate(["/im-tool"]);
  }

  onAllUserPaginateChange() {
    const matTable = document.getElementById('matTable');
    matTable.scrollIntoView();
  }

  public doFilter = (value: string) => {
    if (this.tabSelected === 0)
      this.dataSource.filter = value.trim().toLocaleLowerCase();
    else if (this.tabSelected === 1)
      this.dataSourceExcluded.filter = value.trim().toLocaleLowerCase();
  };

  getCurrentTabSelect(tab: any) {
    this.tabSelected = tab.index;
  }

  getLegacyConnectRecommendedDrugData(customerId) {
    const LISTDATALOAD_KEY = 'Listdataloadkey'
    this.isLegacyConnectMdlLoading = true;
    this.legacyConnectMdlFile = null;
    this.legacyConnectMdlFileName = "";
    this.ngxLoader.start(LISTDATALOAD_KEY);
    this.imtoolService.getLegacyConnectRecommendedDrugData(customerId).subscribe(
      (response) => {

        let result = response.data;

        if(result == null){
          this.isLegacyConnectMdlLoading = false;
          this.ngxLoader.stop(LISTDATALOAD_KEY);
          this.toastService.openToast(
            response.message,
            constants.ToastPanelType.error,
            2
          );
          return
        };

        let datasourceValue = ImToolData.datasource.find(x => x.key == result.dataSource)?.value;
        this.customerName = result.customerName;
        this.targetInstallDate = result.targetInstallDate;
        this.subDeviceTypeName = result.deviceTypeName;
        this.deviceId = result.deviceId;
        this.deviceName = result.deviceName;

        this.analysisDrugList = [];
        this.notAvailableDrugList = [];
        this.excludedDrugList = [];

        let rowSerial = 1;
        result.drugs?.forEach((x) => {
          this.analysisDrugList.push({
            checked: false,
            fileUploadId: x.fileUploadId,
            productID: x.productID,
            ndc: x.ndc,
            drugName: x.drugName,
            productScanCode: x.productScanCode,
            gtin: x.gtin,
            packsize: x.packsize ?? x.packSize,
            purchaseQty: x.purchaseQty,
            drugSchedule: x.drugSchedule,
            drugForm: x.drugForm,
            productType: x.productType,
            uomClass: x.uomClass,
            sellUOM: x.sellUOM,
            slotArea: x.slotArea,
            slotShelf: x.slotShelf,
            slotBin: x.slotBin,
            locType: x.locType,
            rop: x.rop,
            capacity: x.capacity,
            qtyonShelf: x.qtyonShelf,
            lotNo: x.lotNo,
            expDate: x.expDate,
            vialSize: x.vialSize,
            vialCapacity: x.vialCapacity,
            vialEnabled: x.vialEnabled,
            vendorPartNo: x.vendorPartNo,
            specialty: x.specialty,
            ormd: x.ormd,
            refrigerateFlag: x.refrigerateFlag,
            rank: x.rank,
            usage: x.usage,
            rxQty: x.rxQty,
            thirtyDramCapacity: x.thirtyDramCapacity,
            maxRecomendedforUse: x.maxRecomendedforUse,
            isOralSolid: x.isOralSolid,
            cellCapacitySmall: x.cellCapacitySmall,
            cellCapacityLarge: x.cellCapacityLarge,
            nationalDrugCode: x.nationalDrugCode,
            customerDrugName: x.customerDrugName,
            customerIsOralSolid: x.isCustomerOralSolid,
            excludedReason: x.excludedReason,
            na: x.na
          });
        });

        rowSerial = 1;
        result.excludedDrugs?.forEach((x) => {
          this.excludedDrugList.push({
            checked: false,
            fileUploadId: x.fileUploadId,
            productID: x.productID,
            ndc: x.ndc,
            drugName: x.drugName,
            productScanCode: x.productScanCode,
            gtin: x.gtin,
            packsize: x.packsize ?? x.packSize,
            purchaseQty: x.purchaseQty,
            drugSchedule: x.drugSchedule,
            drugForm: x.drugForm,
            productType: x.productType,
            uomClass: x.uomClass,
            sellUOM: x.sellUOM,
            slotArea: x.slotArea,
            slotShelf: x.slotShelf,
            slotBin: x.slotBin,
            locType: x.locType,
            rop: x.rop,
            capacity: x.capacity,
            qtyonShelf: x.qtyonShelf,
            lotNo: x.lotNo,
            expDate: x.expDate,
            vialSize: x.vialSize,
            vialCapacity: x.vialCapacity,
            vialEnabled: x.vialEnabled,
            vendorPartNo: x.vendorPartNo,
            specialty: x.specialty,
            ormd: x.ormd,
            refrigerateFlag: x.refrigerateFlag,
            rank: x.rank,
            usage: x.usage,
            rxQty: x.rxQty,
            thirtyDramCapacity: x.thirtyDramCapacity,
            maxRecomendedforUse: x.maxRecomendedforUse,
            isOralSolid: x.isOralSolid,
            customerIsOralSolid: x.customerIsOralSolid,
            cellCapacitySmall: x.cellCapacitySmall,
            cellCapacityLarge: x.cellCapacityLarge,
            nationalDrugCode: x.nationalDrugCode,
            customerDrugName: x.customerDrugName,
            excludedReason: x.excludedReason,
            na: x.na
          });
        });

        this.dataSource.data = this.analysisDrugList;
        this.dataSourceExcluded.data = this.excludedDrugList;
        this.prepareLegacyConnectMdlFile(result);
        this.ngxLoader.stop(LISTDATALOAD_KEY);
      },
      (error: HttpErrorResponse) => {
        this.isLegacyConnectMdlLoading = false;
        this.ngxLoader.stop(LISTDATALOAD_KEY);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );

      }
    );
  }

  getCurrentDate(): string {
    const currentDate = new Date();
    const options: Intl.DateTimeFormatOptions = {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    };
    return currentDate.toLocaleDateString('en-US', options);
  }
}
